module.exports = __webpack_public_path__ + "static/tickets.fr-09d6aa1639c853eac4b40d692aff368f.png";